module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074ab_banner_800x600.ba3bc181.png";